import React, { useState } from 'react';
import { Button, Box, Typography } from '@mui/material';

interface ExcelUploadProps {
  onUpload: (file: File) => void;
  sampleFileUrl: string;
  isLoading: boolean;
}

export const ExcelUpload: React.FC<ExcelUploadProps> = ({ onUpload, sampleFileUrl, isLoading }) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedFile(event.target.files[0]);
    }
  };

  const handleUpload = () => {
    if (selectedFile) {
      onUpload(selectedFile);
    }
  };

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Button variant="contained" href={sampleFileUrl} download>
          Örnek Dosyayı İndir
        </Button>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Button
          variant="contained"
          component="label"
        >
          Dosya Seç
          <input
            type="file"
            hidden
            onChange={handleFileChange}
            accept=".xlsx, .xls"
          />
        </Button>
        {selectedFile && <Typography>{selectedFile.name}</Typography>}
        <Button
          variant="contained"
          onClick={handleUpload}
          disabled={!selectedFile || isLoading}
        >
          {isLoading ? 'Yükleniyor...' : 'Yükle'}
        </Button>
      </Box>
    </Box>
  );
};
